// extracted by mini-css-extract-plugin
export default {"paper":"LibraryBrowser_paper__1KV5s"};